const cache = {};

export default cache;
